import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProjectPilotRoutingModule } from './project-pilot-routing.module';
import { TeamsComponent } from './team/teams/teams.component';
import { ManageTeamComponent } from './team/manage-team/manage-team.component';
import { TeamRolesComponent } from './team-role/team-roles/team-roles.component';
import { ManageTeamRoleComponent } from './team-role/manage-team-role/manage-team-role.component';
import { MembersComponent } from './member/members/members.component';
import { ManageMemberComponent } from './member/manage-member/manage-member.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ManageProjectComponent } from './project/manage-project/manage-project.component';
import { ProjectsComponent } from './project/projects/projects.component';
import { QuillModule } from 'ngx-quill';
import { ManageEnvironmentComponent } from './project/manage-project/manage-environment/manage-environment.component';
import { ProjectInsightComponent } from './project-insight/project-insight.component';
import { ManageMilestoneComponent } from './milestone/manage-milestone/manage-milestone.component';
import { MilestonesComponent } from './milestone/milestones/milestones.component';
import { TasksComponent } from './task/tasks/tasks.component';
import { TeamInsightComponent } from './team-insight/team-insight.component';
import { MilestoneInsightComponent } from './milestone-insight/milestone-insight.component';
import { ResourceInsightComponent } from './resource-insight/resource-insight.component';
import { TaskDrawerComponent } from './task/task-drawer/task-drawer.component';


@NgModule({
  declarations: [
    TeamsComponent,
    ManageTeamComponent ,
    TeamRolesComponent,
    ManageTeamRoleComponent,
    MembersComponent,
    ManageMemberComponent,
    ManageProjectComponent,
    ProjectsComponent,
    ManageEnvironmentComponent,
    ProjectInsightComponent,
    ManageMilestoneComponent,
    MilestonesComponent,
    TasksComponent,
    TeamInsightComponent,
    MilestoneInsightComponent,
    ResourceInsightComponent,
    TaskDrawerComponent
  ],
  imports: [
    CommonModule,
    ProjectPilotRoutingModule,
    SharedModule,
  ]
})
export class ProjectPilotModule { }
